import { throttle } from 'lodash';
import { useState, useRef, useEffect } from 'react';

export function useLastScrollDirection(
  element: HTMLElement = document.documentElement
) {
  const [scrollDirection, setScrollDirection] = useState<
    'up' | 'down' | 'waiting'
  >('waiting');
  const lastPositionRef = useRef(element.scrollTop);
  useEffect(() => {
    const handleScroll = throttle(() => {
      if (element.scrollTop < lastPositionRef.current) {
        setScrollDirection('up');
      } else {
        setScrollDirection('down');
      }
      lastPositionRef.current = element.scrollTop;
    }, 100);
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [element]);
  return scrollDirection;
}
